
import { CheckIcon } from 'vue-feather-icons';
import { Button } from 'element-ui';
export default {
  components: {
    CheckIcon,
    Button,
  },
};
